export default __webpack_public_path__ + "static/media/colored-contract-transaction.341d378d.svg";